export default __webpack_public_path__ + "static/media/hero-cloud1.64429be6.svg";